import type { AgentSkillListItem } from "@common/schemas/domains/agentSkills/agent-skill.schema";
import { AgentSkillsViewColumn } from "@common/types/views/agentSkillsView";
import { ViewConfig } from "@lib/views";
import { AgentSkillActionsCell } from "./cells/AgentSkillActionsCell";
import { AVAILABLE_IN_LABEL } from "./agentSkillCopy";
import {
    AgentSkillAvailableInCell,
    AgentSkillCategoryCell,
    AgentSkillUpdatedByCell,
    AgentSkillDescriptionCell,
    AgentSkillLoadModeCell,
    AgentSkillTitleCell,
} from "./cells/AgentSkillTextCells";

export type AgentSkillRow = AgentSkillListItem;

export type AgentSkillsViewConfig = ViewConfig<
    AgentSkillRow,
    AgentSkillsViewColumn,
    never
>;

export const agentSkillsViewConfig: AgentSkillsViewConfig = {
    columns: {
        [AgentSkillsViewColumn.TITLE]: {
            accessorKey: "title",
            name: "Skill",
            header: "Skill",
            cell: AgentSkillTitleCell,
            minSize: 220,
            maxSize: 1200,
            immutable: true,
        },
        [AgentSkillsViewColumn.DESCRIPTION]: {
            accessorKey: "description",
            name: "Description",
            header: "Description",
            cell: AgentSkillDescriptionCell,
            minSize: 220,
            maxSize: 1200,
        },
        [AgentSkillsViewColumn.CATEGORY]: {
            accessorKey: "category",
            name: "Category",
            header: "Category",
            cell: AgentSkillCategoryCell,
            minSize: 140,
            maxSize: 240,
        },
        [AgentSkillsViewColumn.UPDATED_BY]: {
            accessorKey: "updatedBy",
            name: "Updated by",
            header: "Updated by",
            cell: AgentSkillUpdatedByCell,
            minSize: 160,
            maxSize: 320,
        },
        [AgentSkillsViewColumn.LOAD_MODE]: {
            accessorKey: "loadMode",
            name: "Frequency",
            header: "Frequency",
            cell: AgentSkillLoadModeCell,
            minSize: 120,
            maxSize: 200,
        },
        [AgentSkillsViewColumn.AVAILABLE_IN]: {
            accessorKey: "summary",
            name: AVAILABLE_IN_LABEL,
            header: AVAILABLE_IN_LABEL,
            cell: AgentSkillAvailableInCell,
            minSize: 120,
            maxSize: 200,
        },
        [AgentSkillsViewColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: AgentSkillActionsCell,
            minSize: 80,
            maxSize: 80,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
